/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `importing` - Importing
* `processing` - Processing
* `import failed` - Import Failed
* `processing failed` - Processing Failed
* `completed` - Completed
 */
export type ActivityImportStatusEnum = typeof ActivityImportStatusEnum[keyof typeof ActivityImportStatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityImportStatusEnum = {
  importing: 'importing',
  processing: 'processing',
  import_failed: 'import failed',
  processing_failed: 'processing failed',
  completed: 'completed',
} as const;
